import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入ElementUI
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/element-variables.scss' 

Vue.use(ElementUI,{ size: 'mini'});
// 引入基础样式
import './assets/css/public.css'  //全局css
// 头部搜索框的样式
import './assets/css/all.scss' 
// 引入图标
import "./assets/iconfont/iconfont.css"

// 引入vuex
import store from './store/index.js';

//引入dayjs
import dayjs from 'dayjs'
Vue.prototype.$dayjs = dayjs;

// 注册指令
import importDirective from '@/directives';
importDirective(Vue);


Vue.config.productionTip = false

new Vue({
  router,
	store,
  render: h => h(App)
}).$mount('#app')
